module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "_1-CN ParaOverride-1",
    attrs: {
      "id": "_idParaDest-2",
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "leading-139-5 CharOverride-1"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("lso ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("by")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Mark Billingham")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The DI Tom Thorne series")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Sleepyhead")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Scaredy")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" Cat")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lazybones")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Burning Girl")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lifeless")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Buried")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Death Message")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Bloodline")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("From the Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitles"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The Demands ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("(")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("published as ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Good as Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "AdCardTitles"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("in the United Kingdom")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Dying ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Hours")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Bones ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Beneath")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Time of Death")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Other fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("In the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Die of Shame")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Rush of Blood")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25966096","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBookVR02451.vue
// module id = 60
// module chunks = 0